import { forwardRef, useImperativeHandle } from "react";
import {
  Button,
  initFlowbite,
  Input,
  Modal,
  modalHandler,
  success,
  UploadImageCard,
  useCustomForm,
  useEffect,
  SwitchInput,
} from "@";
import { bankDefaultValues, bankSchema } from "../utils/validation";
import { saveBankEntity } from "../utils/api";
import { bankEntityFillForm } from "../utils/helpers";

const MODAL_ID = "bank-modal";

const EditBankModal = forwardRef(({ onSuccess }, ref) => {
  const {
    reset,
    register,
    errors,
    handleSubmit,
    isSubmitting,
    isSubmitSuccessful,
    watch,
    setValue,
  } = useCustomForm(bankDefaultValues, bankSchema);

  const clearForm = () => {
    reset(bankDefaultValues);
  };

  const submit = async (form) => {
    try {
      await saveBankEntity(form);
      success("تم الحفظ بنجاح");
      modalHandler(MODAL_ID);
      clearForm();
      onSuccess?.();
    } catch (error) {}
  };

  useEffect(() => {
    initFlowbite();
  }, []);

  useImperativeHandle(ref, () => ({
    open: (bank) => {
      reset(bankEntityFillForm(bank));
      modalHandler(MODAL_ID);
    },
  }));

  return (
    <>
    <button
      data-modal-target={MODAL_ID}
      data-modal-toggle={MODAL_ID}
      className="hidden"
    />
    <Modal
      id={MODAL_ID}
      close={clearForm}
      title="تعديل البنك"
      description="هنا يمكنك تعديل اسم البنك والصورة"
    >
      <form onSubmit={handleSubmit(submit)} className="relative p-4">
        <Input
          style="mb-5"
          label="اسم البنك"
          error={errors.name}
          input={register("name")}
        />


<div className="mb-5">
            <SwitchInput
              label="نشط"
              checked={watch("isActive")}
              change={(value) => setValue("isActive", value)}
              isBordered={true}
            />
          </div>

        <UploadImageCard
        star={!watch("imageFullUrl")}
          show={true}
          title="صورة البنك"
          src={watch("imageFullUrl")}
          success={isSubmitSuccessful}
          error={errors.image?.message}
          upload={(file) => setValue("image", file)}
        />

        <Button isLoading={isSubmitting} type="submit" title="حفظ البيانات" />
      </form>
    </Modal>
    </>
  );
});

EditBankModal.MODAL_ID = MODAL_ID;

export default EditBankModal;
